const kollectAiPermissions = {
  permissionSummary:
    '/account/api/v1/roles_and_permissions/permissions_summary',
  permissionView: '/account/api/v1/roles_and_permissions/permission',
  clientConfig: '/account/api/v1/roles_and_permissions/get_client_config',
};

export default kollectAiPermissions;
